<template lang="pug">
b-modal#modal-add-edit-room.modal-background(
  :title='title'
  size="lg"
  hide-footer
  no-close-on-backdrop
  hide-header-close
  @show="resetModal"
  @hidden="resetModal"
)
  .container.add-edit-room
    form#room-form(@submint='onSubmit')
      .form-row
        .form-group.col-md-6
          label.form-label(for='room-number')
            | {{ $t('room.number') }}
            span(v-if="property.existing")  *
            |  {{ $t('half_width') }}
          input#room-number.form-control(
            :class="{ 'red-bordered': !isEmpty(errors.number) }"
            type='number'
            name='number'
            v-model='room.number'
            min='1',
            step='1'
            @keyup='asNumber($event)'
            @keypress='filterDigits'
            :required='property.existing'
          )
          .invalid-feedback(v-for='obj in errors.number', role='alert') {{ getError(obj) }}
        .form-group.col-md-6
          label.form-label(for='room-floor') {{ $t('room.floor') }} * {{ $t('half_width') }}
          input#room-floor.form-control(
            :placeholder="$t('create_property_page.example_floors')"
            :class="{ 'red-bordered': !isEmpty(errors.floor) }"
            type='number'
            name='floor'
            v-model='room.floor'
            min='-5'
            step='1'
            required=''
          )
          .invalid-feedback(v-for='obj in errors.floor', role='alert') {{ getError(obj) }}
      .form-row
        .form-group.col-md-6
          label.form-label(for='room-layout') {{ $t('room.layout') }} *
          select#room-layout.form-control.select-wraper(
            :class="{ 'red-bordered': !isEmpty(errors.layout) }"
            v-model='room.layout', name='layout', required='')
            option(value='1R') 1R
            option(value='1K') 1K
            option(value='1DK') 1DK
            option(value='1LDK') 1LDK
            option(value='2K') 2K
            option(value='2DK') 2DK
            option(value='2LDK') 2LDK
            option(value='3K') 3K
            option(value='3DK') 3DK
            option(value='3LDK') 3LDK
            option(value='4K') 4K
            option(value='4DK') 4DK
            option(value='4LDK') 4LDK~
          i.fa.fa-chevron-down.icon-action
          .invalid-feedback(v-for='obj in errors.layout', role='alert') {{ getError(obj) }}
        .form-group.col-md-6
          label.form-label(for='room-area') {{ $t('room.area') }} * {{ $t('half_width') }}
          input#room-area.form-control(
            :placeholder="$t('create_property_page.example_area')"
            :class="{ 'red-bordered': !isEmpty(errors.area) }"
            type='number'
            area='area'
            name='area'
            v-model='room.area'
            min='0'
            max='99000000'
            step='.01'
            required=''
          )
          .invalid-feedback(v-for='obj in errors.area', role='alert') {{ getError(obj) }}
      .form-row
        .form-group.col-md-6
          label.form-label(for='room-current-rent-fee')
            | {{ $t('room.current_rent_fee') }}
          input#room-current-rent-fee.form-control(
            :placeholder="$t('create_property_page.example_current_rent_fee')"
            :class="{ 'red-bordered': !isEmpty(errors.current_rent_fee) }"
            type='number', name='current_rent_fee', v-model='room.current_rent_fee', min='0', max='99000000', step='.01', :disabled='!property.existing')
          .invalid-feedback(v-for='obj in errors.current_rent_fee', role='alert') {{ getError(obj) }}
      .form-group.mt-2
        h2 {{ $t('room.optional') }}
      .form-row
        .form-group.col-md-6
          label.form-label(for='room-direction') {{ $t('room.direction') }}
          select#room-direction.form-control.select-wraper(v-model='room.direction', name='direction')
            option(value='South') {{ $t("directions.South") }}
            option(value='Southeast') {{ $t("directions.Southeast") }}
            option(value='Southwest') {{ $t("directions.Southwest") }}
            option(value='East') {{ $t("directions.East") }}
            option(value='West') {{ $t("directions.West") }}
            option(value='North') {{ $t("directions.North") }}
            option(value='Northeast') {{ $t("directions.Northeast") }}
            option(value='Northwest') {{ $t("directions.Northwest") }}
          i.fa.fa-chevron-down.icon-action
          .invalid-feedback(v-for='obj in errors.direction', role='alert') {{ getError(obj) }}

      .form-row
        .form-group.col-md-10(v-if='property.existing')
          .row
            .col-12
              label.form-label {{ `${$t('room.renovation_date')}` }}

          .row
            .col-3.pt-2 {{ $t('room.interior') }}
            .col-2.pt-1
              label.switch
                input(type="checkbox" v-model="toggles.interior" @change="toggleDate($event, 'renovation_date_interior')")
                span.slider.round
            .dates-width(v-if="toggles.interior")
              date-picker(
                input-class='form-control readonly'
                :input-attr="{ required: true }"
                name='renovation_date_interior'
                :placeholder="$t('create_property_page.example_date')"
                :editable='false'
                v-model='room.renovation_date_interior'
                :format='datePicker.format'
                :not-before="datePicker.disabledDates.renovation_date.before"
                :not-after="datePicker.disabledDates.renovation_date.after"
                :lang='datePicker.lang'
                :value-type="datePicker.internalFormat"
              )
          .row.mb-3
            .col-12
              .invalid-feedback(v-for='obj in errors.renovation_date_interior', role='alert') {{ getError(obj) }}

          .row
            .col-3.pt-2 {{ $t('room.wet') }}
            .col-2.pt-1
              label.switch
                input(type="checkbox" v-model="toggles.wet" @change="toggleDate($event, 'renovation_date_wet')")
                span.slider.round
            .dates-width(v-if="toggles.wet")
              date-picker(
                input-class='form-control readonly'
                :input-attr="{ required: true }"
                name='renovation_date_wet'
                :placeholder="$t('create_property_page.example_date')"
                :editable='false'
                v-model='room.renovation_date_wet'
                :format='datePicker.format'
                :not-before="datePicker.disabledDates.renovation_date.before"
                :not-after="datePicker.disabledDates.renovation_date.after"
                :lang='datePicker.lang'
                :value-type="datePicker.internalFormat"
              )
          .row
            .col-12
              .invalid-feedback(v-for='obj in errors.renovation_date_wet', role='alert') {{ getError(obj) }}

      .form-row.mt-4
        .col-md-4.col-sm-6(v-for='facility in roomFacilities', :key='facility.id')
          ul.pl-0
            li
              label.checkbox-wrapper {{ $t(`facilities.${facility.code}`) }}
                input(type='checkbox', :value='facility.id', v-model='room.facility_ids')
                span.checkmark
    .row.mt-3
      .col.text-right
        button.btn.btn-outline-primary.px-4.py-0.mr-3(@click.prevent="closeModal") {{ $t('room.cancel') }}
        input.btn.btn-primary.px-4.py-0(type='button', @click.prevent='onSubmit', :value="$t('confirm')")
</template>

<script>
import errorMessageMixin from '@/mixins/error-message'
import DatePicker from 'vue2-datepicker'
import fecha from 'fecha'
import { isEmpty, size, filter, some } from 'lodash'

export default {
  components: {
    DatePicker
  },

  mixins: [errorMessageMixin],

  props: {
    facilities: {
      type: Array,
      default() {
        return []
      }
    },
    property: {
      type: Object,
      default() {
        return {}
      }
    },
    room: {
      type: Object,
      default() {
        return {}
      }
    },
    add: {
      type: Boolean,
      default() {
        return true
      }
    },
    rooms: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      errors: {},
      datePicker: {
        disabledDates: {
          renovation_date: {
            before: this.defaultBeforeBorderDate,
            after: this.defaultAfterBorderDate
          }
        },
        format: 'YYYY年M月D日',
        internalFormat: {
          value2date(value) {
            if (!value) {
              return null
            }
            return new Date(value)
          },
          date2value(date) {
            if (!date) {
              return
            }

            return fecha.format(date, 'YYYY-MM-DD')
          }
        },
        lang: {
          days: ['日', '月', '火', '水', '木', '金', '土'],
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
      },
      toggles: {
        interior: false,
        wet: false
      }
    }
  },

  computed: {
    title() {
      if (this.add) {
        return this.$t('room.add_room')
      } else {
        return this.$t('room.edit_room')
      }
    },

    notDeletedRooms() {
      return filter(this.rooms, room => !room._destroy)
    },

    defaultBeforeBorderDate () {
      return this.property.built_date || new Date('1000-01-01')
    },

    defaultAfterBorderDate () {
      return new Date()
    },

    roomFacilities() {
      return this.facilities.filter((facility) => {
        return facility.room_facility
      })
    }
  },

  watch: {
    room() {
      this.toggles.interior = !!this.room.renovation_date_interior
      this.toggles.wet = !!this.room.renovation_date_wet
    }
  },

  mounted() {
    if (this.property.existing) {
      this.datePicker.disabledDates.renovation_date.before = new Date(this.property.built_date)
    }
  },

  methods: {
    isEmpty,

    onSubmit() {
      if (this.validate()) {
        this.$emit('onRoomChanged', this.room)
        this.closeModal()
      }
    },

    validate() {
      this.errors = {}

      this.validateForm()
      this.validateDates()
      this.validateArea()
      this.validateFloor()
      this.validateNumber()

      return (size(this.errors) == 0)
    },

    validateForm() {
      const nodes = document.querySelectorAll(`#room-form :invalid`)

      if (nodes.length) {
        nodes.forEach(node => {
          this.errors = { ...this.errors, [node.name]: [{ error: node.validationMessage }] }
        })
      }
    },

    validateDates() {
      if (this.room.renovation_date_interior) {
        if (new Date(this.property.built_date).getTime() > new Date(this.room.renovation_date_interior).getTime()) {
          this.errors.renovation_date_interior = [{ error: 'renovation_date_should_be_greater_built_date' }]
        }
      }

      if (this.room.renovation_date_wet) {
        if (new Date(this.property.built_date).getTime() > new Date(this.room.renovation_date_wet).getTime()) {
          this.errors.renovation_date_wet = [{ error: 'renovation_date_should_be_greater_built_date' }]
        }
      }
    },
    validateArea() {
      if (!this.property.area) {
        return
      }

      let sum = this.notDeletedRooms.reduce((accumulator, room) => {
        return accumulator + parseFloat(room.area)
      }, 0)

      sum += parseFloat(this.room.area)

      if (sum > this.property.area) {
        this.errors.area = [{ error: 'total_sum_greater_then_property_area' }]
      }
    },
    validateFloor() {
      if (!this.property.floors) {
        return
      }

      if (parseInt(this.room.floor) > parseInt(this.property.floors)) {
        this.errors.floor = [{ error: 'floor_must_be_smaller' }]
      }
    },
    validateNumber() {
      if (parseInt(this.room.number) <= 0) {
        this.errors.number = [{ error: 'room_number_must_be_positive' }]
      }

      const roomsWithNumber = filter(this.rooms, 'number')
      const notUnique = some(roomsWithNumber, room => {
        return room.number == this.room.number
      })
      if (this.room.number && notUnique) {
        this.errors.number = [{ error: 'room_number_must_be_unique' }]
      }
    },

    closeModal() {
      this.$bvModal.hide('modal-add-edit-room')
    },

    resetModal() {
      this.errors = {}
    },

    asNumber({ target: { name, value }}) {
      this.room[name] = Number(value)
    },

    filterDigits(event) {
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault()
      }
    },

    toggleDate(event, date) {
      if (!event.target.checked) {
        this.room[date] = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-primary,
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
  border-color: transparent !important;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 38px;
}

.btn-outline-primary,
.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active {
  background: transparent;
  border: 1px solid rgba(0, 156, 234, 0.3);
  border-radius: 4px;
  color: #009cea;
  font-size: 14px;
  height: 40px;
  line-height: 38px;
}

.modal-background {
  ::v-deep .modal-content {
    background-color: #fcfdfe !important;
  }

  ::v-deep .modal-title {
    padding-left: 15px;
  }
}

h2 {
  color: #313541;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0;
}

.add-edit-room {
  ul {
    list-style-type: none;
  }

  .invalid-feedback {
    color: #dc3545;
    display: block;
    font-size: 80%;
    margin-top: 0.25rem;
    width: 100%;
  }

  .form-label {
    color: #7c91a7;
    font-size: 11px;
    font-weight: 700;
  }

  .icon-action {
    color: #7c91a7;
    font-size: 16px;

    &:hover {
      color: #009cea;
    }
  }
}

input::placeholder {
  opacity: 0.5;
}

.dates-width {
  width: 50%;
}

@media (max-width: 992px) {
  .dates-width {
    padding-left: 15px;
    width: 97% !important;
  }
}
</style>
